var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuSelectedHabit = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 39.54 39.44",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.77,
    y1: 39.22,
    x2: 19.77,
    y2: 0.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b9c49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#49a845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#83c03e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9aca3c"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M19.77,39.22C9.02,39.22,.27,30.47,.27,19.72S9.02,.22,19.77,.22s19.5,8.75,19.5,19.5-8.75,19.5-19.5,19.5Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1,14.42l-1.75-1.74c-.1-.1-.24-.16-.4-.14-.15,.01-.28,.09-.37,.21l-6.66,9.44-3.07-2.56c-.2-.17-.49-.15-.67,.03l-1.74,1.74c-.1,.1-.15,.23-.15,.37,0,.14,.06,.27,.17,.36l5.23,4.65c.09,.08,.21,.13,.33,.13,.02,0,.03,0,.05,0,.14-.01,.27-.09,.35-.2l8.72-11.62c.15-.2,.13-.48-.05-.65Z",
    style: {
      fill: "#fff"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuSelectedHabit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_Selected_Habit.8482fd22.svg";
export { ForwardRef as ReactComponent };